import { useContext } from "react";
import styles from "./styles.module.css";
import { MdAdd } from "react-icons/md";
import { UtilitiesDisbatch } from "../../../contexts/utilities";
export default function Utilities({ options, onSelect, selected }) {
  const disbatch = useContext(UtilitiesDisbatch);

  const handleAdd = () => {
    disbatch({ type: "setOpen", value: true });
    disbatch({ type: "setAdd", value: true });
  };
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>Utilities</div>
      {options.map((x) => {
        return (
          <div
            key={x.code}
            onClick={() => onSelect(x)}
            className={
              selected.value === x.code
                ? styles.item + " " + styles.selected
                : styles.item
            }
          >
            {x.name}
          </div>
        );
      })}
      <div onClick={handleAdd} className={styles.addItem}>
        <MdAdd style={{ marginRight: 6 }} /> ADD
      </div>
    </div>
  );
}
